import { Stack, TextField, Toggle } from '@fluentui/react';
import * as React from 'react';
import { IOrderListFilter } from '../../../../Models/Order/IOrderListFilter'

interface IOrderListAdminFilterViewProps {
    filter: IOrderListFilter;
    propertyChanged: (key: string, value: string | boolean | undefined) => void;
}



 


export const OrderListAdminFilterViewPage: React.FunctionComponent<IOrderListAdminFilterViewProps> = (props) => {

    
    

    return (<Stack horizontal tokens={{ childrenGap: 10 }} styles={{ root: { paddingTop: 15 } }} verticalAlign="center">
        <Stack.Item grow>
            <TextField label="Zákazník" placeholder="Zadejte název zákazníka" value={props.filter.name} onChange={(e, v) => props.propertyChanged("name", v ? v : '')}></TextField>
        </Stack.Item>
        <Stack.Item grow>
        <TextField label="Akce" placeholder="Zadejte název akce" value={props.filter.eventName} onChange={(e, v) => props.propertyChanged("eventName", v ? v : '')}></TextField>
        </Stack.Item >
        <Stack.Item grow>
            <Toggle label="Pouze nedokčené" checked={props.filter.onlyUnfinished} onChange={(e, v) => props.propertyChanged("onlyUnfinished", v ? v : false)}></Toggle>
        </Stack.Item>
    </Stack>)
}
